import { createContext } from 'react';

export type PromptOptions = {
  title?: string;
  message?: string;
  label?: string;
  defaultValue?: string;
  placeholder?: string;
  confirmText?: string;
  cancelText?: string;
  multiline?: boolean;
  required?: boolean;
};

export type PromptContextType = {
  prompt: (options: PromptOptions) => Promise<string | null>;
};

export const PromptContext = createContext<PromptContextType>({
  prompt: async () => null,
});
